import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Button,
  IconButton,
  Drawer,
  Grid,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { formatReportingDateMonth } from "../../../utils/formatDate";
import DocumentItem from "../../../Components/Masters/DocumentItem";

function ViewData({
  title,
  inputData,
  element,
  viewData,
  setViewData,
  handleEdit,
  companyAdmin,
  setData,
}) {
  const [filteredData, setFilteredData] = useState({});

  useEffect(() => {
    if (element) {
      setFilteredData(element);
    }
  }, [element]);

  const getFieldValue = (fieldName) => {
    const masterFields = new Set([
      "franchiseName",
      "franchiseId",
      "country",
      "locationAddress",
      "contactPerson",
      "franchiseType",
    ]);

    let value = filteredData?.[fieldName];
    if (
      masterFields.has(fieldName) &&
      (value === undefined || value === null || value === "")
    ) {
      const m = filteredData?.franchiseMaster;
      if (m && typeof m === "object") {
        value = m[fieldName];
      }
    }

    if ((fieldName === "reportingStart" || fieldName === "reportingEnd") && value) {
      return formatReportingDateMonth(value);
    }

    if (fieldName === "reportingPeriod" && value && typeof value === "object") {
      const start = value.start ? formatReportingDateMonth(value.start) : "";
      const end = value.end ? formatReportingDateMonth(value.end) : "";
      const combined = [start, end].filter(Boolean).join(" - ");
      value = combined || "-";
    }

    if (value === undefined || value === null || value === "") {
      return "-";
    }

    return value;
  };

  const renderField = (fieldName) => {
    const input = inputData?.find((item) => item.fieldName === fieldName);
    if (!input) return null;

    return (
      <Box mb={1}>
        <Typography
          variant="subtitle1"
          sx={{
            fontWeight: "bold",
            wordBreak: "break-word",
          }}
        >
          {input.title}
        </Typography>
        <div style={{ wordBreak: "break-word" }}>{getFieldValue(fieldName)}</div>
      </Box>
    );
  };

  const list = () => (
    <Box
      display="flex"
      gap={3}
      sx={{
        width: "26.5rem",
        maxWidth: "100%",
        height: "100vh",
        justifyContent: "space-between",
        backgroundColor: "transparent",
      }}
    >
      <Box
        sx={{
          backgroundColor: "#fff",
          height: "3%",
          padding: "13px",
          margin: "30px 0 0 0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "80%",
          width: "5%",
        }}
      >
        <IconButton
          onClick={() => {
            setViewData(false);
            setData({});
          }}
          sx={{ color: "black" }}
        >
          <CloseIcon sx={{ fontSize: "1.2rem" }} />
        </IconButton>
      </Box>
      <Box
        sx={{ 
          p: 3, 
          width: "100%", 
          backgroundColor: "#fff", 
          overflow: "auto",
        }}
      >
        <Typography
          variant="h6"
          sx={{
            textDecoration: "underline",
            fontWeight: "bold",
            mb: 2,
          }}
        >
          {title}
        </Typography>
        <Grid container spacing={2}>
          {[
            ["franchiseName", "franchiseId"],
            ["country", "locationAddress"],
            ["contactPerson", "reportingStart"],
            ["reportingEnd", "franchiseType"],
            ["scope1EmissionsMetricTon", "scope2EmissionsMetricTon"],
            ["scope3EmissionsMetricTon", "remark"],
          ].map(([leftField, rightField]) => (
            <React.Fragment key={`${leftField}-${rightField}`}>
              <Grid item xs={6}>
                {renderField(leftField)}
              </Grid>
              <Grid item xs={6}>
                {renderField(rightField)}
              </Grid>
            </React.Fragment>
          ))}
        </Grid>

        <Box sx={{ mt: 2 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
            Documents (optional)
          </Typography>
          {/* Render Images First */}
          {element && element?.documents?.length > 0 ? (
            <Box
              display="flex"
              flexDirection="column"
              gap={2}
              sx={{ width: "100%" }}
            >
              <Box display="flex" flexWrap="wrap" gap={1}>
                {element?.documents
                  .filter((url) =>
                    ["png", "jpg", "jpeg"].includes(
                      url.split(".").pop().toLowerCase()
                    )
                  )
                  ?.map((url, index) => (
                    <DocumentItem key={`image-${index}`} url={url} />
                  ))}
              </Box>

              {/* Render Other Documents */}
              <Box display="flex" flexWrap="wrap" gap={1}>
                {element?.documents
                  .filter(
                    (url) =>
                      !["png", "jpg", "jpeg"].includes(
                        url.split(".").pop().toLowerCase()
                      )
                  )
                  ?.map((url, index) => (
                    <DocumentItem key={`file-${index}`} url={url} />
                  ))}
              </Box>
            </Box>
          ) : (
            <Typography>-</Typography>
          )}
        </Box>

        {typeof handleEdit === "function" && !companyAdmin ? (
          <Button
            variant="contained"
            sx={{ mt: 2, backgroundColor: "#0a3f73", textTransform: "none" }}
            onClick={() => handleEdit(element)}
          >
            Edit
          </Button>
        ) : null}
      </Box>
    </Box>
  );

  return (
    <Drawer
      anchor="right"
      open={viewData}
      onClose={() => {
        setViewData(false);
        setData({});
      }}
      sx={{
        "& .MuiDrawer-paper": {
          backgroundColor: "transparent",
          boxShadow: "none",
        },
      }}
    >
      {list()}
    </Drawer>
  );
}

export default ViewData;

